// These headers will prevent the browser from checking the cache before hitting
// the thumbnail URL endpoint
export const DO_NOT_CACHE_HEADERS = {
  pragma: 'no-cache',
  'cache-control': 'no-cache',
};
